module.exports = __webpack_public_path__ + "ms.701093b48f1b1b5f8961.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ms.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ms.svg
// module chunks = styles